import React from 'react'
import { Col, Container, Row } from 'react-bootstrap'

export default function AboutOne() {
    return (
        <Container className="container mt-2 mb-3">
            <Row >
                <Col>
                    <div className="row mt-3 mb-3" >
                    <div className="col" >
                    <div className='home_row_line' ></div>
                    <h3 className="home-services-main-title">About Us</h3>
                    <div className="row row-cols-1 row-cols-lg-4 row-cols-md-2 row-cols-xs-1 g-2 g-lg-3 justify-content-center" >
                    </div>
                </div>
                    </div>
                </Col>
            </Row>
            <Row>
                <Col xl={6} className="mt-3" >
                    <img className="about-image" src="/images/pages/home/about_img.jpg" alt="Loading.." />
                </Col>
                <Col xl={6} className="homeabout-col">
                    <h3 className='homeabout-title'> Dr. BHUPATHI RAJENDRA PRASAD </h3>
                    <p>Sr. Consultant – Surgical Gastroenterology, GI & HPB Onco Surgery, General & Laparoscopic Surgery</p>
                    <p> Dr. Bhupathi Rajendra Prasad completed MBBS from KMC, Warangal, Telangana, MS (General Surgery) from Osmania & Superspeciality from NIMS, Hyd. Others include IHPBA certificate course, FMAS skill course. He is well trained in Laparoscopic surgery at excellent centers.  </p> <div />
                    <p> He has given several lectures, chaired sessions, presented papers & posters at various conferences. He is an accomplished member of various societies which includes ASI, AMASI, IMA and IASG.  </p>
                    <p> Dr. Bhupathi Rajendra Prasad has vast experience in surgical field & has successfully performed more than 5000 Surgeries (Major & complex surgeries of GIT including Liver, Gall bladder, Biliary tract, Pancreas, Spleen, Abdominal wall & retroperitoneum). His special interests include complex GI/HPB & Laparoscopic surgery, Patient Centric care, teaching & training students.</p>
                </Col>
            </Row>
        </Container>
    )
}
